export default "__VITE_ASSET__BLyMY5KY__"